import React from "react";
import {Box, Grid, Typography} from "@material-ui/core";
import {useSelector} from "react-redux";
import {RootState} from "../../../../reducers";
import {useActions} from "../../../../actions";
import numeral from "numeral";
import {getAllocationFromStressRequest} from "../../../../utils/commonFunc";
import useGetAllocations from "../../../../hooks/useGetAllocations";
import {validObj} from "../../../../utils/commonUtils";
import * as EstimationActions from "../../../../actions/estimation";


const StressProposalSummary = ({userId, clientPolicyId, carrierId, strategyId, callingFrom}: {
    userId: string,
    clientPolicyId: string,
    carrierId?: number,
    strategyId?: number,
    callingFrom: string
}) => {

    const {user} = useSelector((state: RootState) => state.auth);
    const clientPolicy = user && user.client && user.client.clientPolicies && user.client.clientPolicies.length > 0 && user.client.clientPolicies[0];
    if (!carrierId) {
        carrierId = (clientPolicy && clientPolicy.carrier && clientPolicy.carrier.id) || (clientPolicy && clientPolicy.carrierId) || 0;
    }
    if (!strategyId) {
        strategyId = (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.id) || (clientPolicy && clientPolicy.strategyId) || 0;
    }
    const allocationQuestion = useGetAllocations(carrierId as number, strategyId as number)
    const [estimatedDetails, setEstimatedDetails] = React.useState<any>(null);
    const estimationActions = useActions(EstimationActions);

    const success = estimatedDetails && estimatedDetails.stressResponse && estimatedDetails.stressResponse;
    const common = estimatedDetails && estimatedDetails.stressResponse && estimatedDetails.stressResponse.common;


    const agentName = common && common.agent && common.agent.fullname;
    const fullName = common && common.fullname;
    const allocationFromStressRequest = allocationQuestion && validObj(allocationQuestion) && estimatedDetails && estimatedDetails.stressRequest ? getAllocationFromStressRequest(allocationQuestion, estimatedDetails) : [];

    const initialTotalDeathBenefit = numeral(success && success.stress && success.stress.totaldeathbenefit || 0).format("$0,0");
    const contributionAmount = numeral(success && success.stress && success.stress.contributionamount || 0).format("$0,0");
    const annualPremium = numeral(common && common.premium || 0).format("$0,0");

    React.useEffect(() => {
        (async () => {
            let estimationDetails: any = await estimationActions.getEstimationDetailsByUserId(userId, callingFrom, clientPolicyId);
            if (estimationDetails && estimationDetails.id) {
                if (!!(estimationDetails && estimationDetails.stressResponse)) {
                    let responsePayload: any = JSON.parse(estimationDetails && estimationDetails.stressResponse);
                    console.log(responsePayload, "responsePayload1");
                    if (responsePayload && responsePayload.success) {
                        console.log(responsePayload && responsePayload.success, "responsePayload2");
                        setEstimatedDetails({
                            stressResponse: responsePayload.success,
                            stressRequest: estimationDetails.stressRequest
                        });
                    } else {
                        console.log(responsePayload && responsePayload.success, "responsePayload3");
                        setEstimatedDetails([]);
                    }
                } else {
                    setEstimatedDetails([]);
                }
            }
        })();
    }, [userId, clientPolicyId, callingFrom]);

    return (
            <Box p={4} mx="auto">
                <Typography variant="h6" className={"mb30"}>
                    Proposal Summary
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography>Client Name:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">{fullName}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography>Agent Name:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">{agentName}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography>Initial Death Benefit:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">{initialTotalDeathBenefit}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography>Client Contribution (includes trust fee):</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">{contributionAmount}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography>Total Premium:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">{annualPremium}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography>Index Options:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">
                            {
                                allocationFromStressRequest.map((i: { label: any; weight: any; }, idx: any) => (
                                        <React.Fragment key={idx}>
                                            {i.label}, {i.weight}% <br/>
                                        </React.Fragment>
                                ))
                            }
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
    );
};

export default StressProposalSummary;
